import {useRef,useState} from 'react';

// Preserve the existing Excel format. Load the spreadsheet libraries on click,
// rather than during report search, filtering, and page rendering.
export default function ReportExcel({report}){
 const inFlight=useRef(false),[busy,setBusy]=useState(false),[failed,setFailed]=useState(false);
 async function download(){
  if(inFlight.current)return;
  inFlight.current=true;setBusy(true);setFailed(false);
  try{
   const [xlsxModule,fileSaver]=await Promise.all([import('xlsx'),import('file-saver')]);
   const XLSX=xlsxModule.default||xlsxModule;
   const saveAs=fileSaver.saveAs||fileSaver.default;
   const rows=[[report.title],...report.metrics,[],report.columns,...report.rows.map(row=>row.cells),
    ...(report.movements?.length?[[],['Saved stock movements'],
     ['Record ID','Type','Inventory','Status','Created','Recorded value'],
     ...report.movements.map(row=>row.cells)]:[])];
   const sheet=XLSX.utils.aoa_to_sheet(rows),book=XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(book,sheet,'Report');
   saveAs(new Blob([XLSX.write(book,{bookType:'xlsx',type:'array'})],
    {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
    report.title.replace(/[^a-zA-Z0-9._-]/g,'_')+'.xlsx');
  }catch(error){console.error('Report Excel export failed',error);setFailed(true);}
  finally{inFlight.current=false;setBusy(false);}
 }
 return <button type="button" className="topBtn" disabled={busy} onClick={download}
  title="Export all currently filtered report records to Excel">
  {busy?'Preparing Excel…':failed?'Retry Excel':'Export Excel'}
 </button>;
}
